import client, { profitQuery, unwrap } from './client';

export const getInvoices = (month) =>
  client.get(`/profit-pulse/invoices${profitQuery({ month })}`).then(unwrap);

export const createInvoice = (body) =>
  client.post('/profit-pulse/invoices', body).then(unwrap);

export const deleteInvoice = (id) =>
  client.delete(`/profit-pulse/invoices/${id}`).then(unwrap);
